import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.ticketing.list');
import { OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-ticketing-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.ticketing.list/view.scss */
/* src/app/portal.ticketing.list/view.scss: no such file or directory */`],
})
export class PortalTicketingListComponent implements OnInit {
    @Input() forcedVariant: string = '';
    @Input() basePath: string = '/tickets';

    public tickets: any[] = [];
    public loading: boolean = true;
    public page: number = 1;
    public dump: number = 20;
    public total: number = 0;
    public status: string = '';
    public variant: string = '';
    public text: string = '';
    public stats: any = {};
    public seedingExamples: boolean = false;
    public seedMessage: string = '';
    public Math = Math;
    public gStatusItems: any[] = [
        { status: '', label: '전체', key: 'total', short: '전체' },
        { status: 'escalated', label: '접수 대기', key: 'escalated', short: '접수' },
        { status: 'infra_processing', label: '처리중', key: 'infra_processing', short: '처리' },
        { status: 'reassigned', label: '재이관', key: 'reassigned', short: '이관' },
        { status: 'infra_resolved', label: '처리 완료', key: 'infra_resolved', short: '완료' },
        { status: 'closed', label: '종료', key: 'closed', short: '종료' }
    ];
    private queryReady: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( ActivatedRoute)  private route: ActivatedRoute,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.route.queryParamMap.subscribe((params) => {
            const nextStatus = params.get('status') || '';
            const routeVariant = params.get('variant') || '';
            const nextVariant = this.forcedVariant || routeVariant || this.pathVariant();
            if (!this.queryReady || nextStatus !== this.status || nextVariant !== this.variant) {
                this.status = nextStatus;
                this.variant = nextVariant;
                this.page = 1;
                this.queryReady = true;
                this.load();
            }
        });
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("list", {
            page: this.page,
            dump: this.dump,
            status: this.status,
            text: this.text,
            variant: this.variant
        });
        if (code === 200) {
            this.tickets = data.rows || [];
            this.total = data.total || 0;
            this.stats = data.stats || {};
        }

        this.loading = false;
        await this.service.render();
    }

    public async filterByStatus(status: string) {
        const nextStatus = this.status === status ? '' : status;
        this.page = 1;
        await this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { status: nextStatus || null },
            queryParamsHandling: 'merge'
        });
    }

    public async search() {
        this.page = 1;
        await this.load();
    }

    public async seedExamples() {
        if (this.seedingExamples) return;
        this.seedingExamples = true;
        this.seedMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("seed_examples", { variant: this.variant });
            if (code === 200) {
                this.seedMessage = data.message || '예시 티켓을 추가했습니다.';
                this.page = 1;
                this.text = '';
                if (this.status) {
                    await this.router.navigate([], {
                        relativeTo: this.route,
                        queryParams: { status: null },
                        queryParamsHandling: 'merge'
                    });
                } else {
                    await this.load();
                }
            } else {
                this.seedMessage = data?.message || '예시 추가에 실패했습니다.';
            }
        } catch (e) {
            this.seedMessage = '예시 추가에 실패했습니다.';
        }

        this.seedingExamples = false;
        await this.service.render();
    }

    public async deleteExample(ticket: any, event: Event) {
        event.preventDefault();
        event.stopPropagation();
        if (!ticket?.id || !ticket.can_delete) return;

        const confirmed = await this.service.modal.show({
            title: '예시 티켓 삭제',
            message: '이 예시 티켓과 관련 로그를 삭제하시겠습니까?',
            cancel: '취소',
            action: '삭제',
            actionBtn: 'error',
            status: 'warning'
        });
        if (!confirmed) return;

        const { code, data } = await wiz.call("delete_example", { escalation_id: ticket.id });
        if (code === 200) {
            this.seedMessage = data?.message || '예시 티켓을 삭제했습니다.';
            await this.load();
        } else {
            this.seedMessage = data?.message || '예시 티켓 삭제에 실패했습니다.';
            await this.service.render();
        }
    }

    public async prevPage() {
        if (this.page > 1) {
            this.page--;
            await this.load();
        }
    }

    public async nextPage() {
        if (this.page * this.dump < this.total) {
            this.page++;
            await this.load();
        }
    }

    public statusLabel(status: string) {
        const map: any = {
            'receipt_waiting': '접수 대기',
            'escalated': '접수 대기',
            'infra_processing': '처리중',
            'in_progress': '처리중',
            'reassigned': '재이관',
            'reassigned_resolved': '재이관 처리 완료',
            'infra_resolved': '처리 완료',
            'returned': '반려',
            'closed': '처리 완료'
        };
        return map[status] || status;
    }

    public statusClass(status: string) {
        const map: any = {
            'receipt_waiting': 'bg-blue-50 text-blue-700 border-blue-200',
            'escalated': 'bg-blue-50 text-blue-700 border-blue-200',
            'infra_processing': 'bg-yellow-50 text-yellow-700 border-yellow-200',
            'in_progress': 'bg-yellow-50 text-yellow-700 border-yellow-200',
            'reassigned': 'bg-violet-50 text-violet-700 border-violet-200',
            'reassigned_resolved': 'bg-emerald-50 text-emerald-700 border-emerald-200',
            'infra_resolved': 'bg-green-50 text-green-700 border-green-200',
            'returned': 'bg-red-50 text-red-700 border-red-200',
            'closed': 'bg-green-50 text-green-700 border-green-200'
        };
        return map[status] || 'bg-gray-50 text-gray-600 border-gray-200';
    }

    public priorityLabel(priority: string) {
        const map: any = { 'low': '낮음', 'medium': '중간', 'high': '높음', 'critical': '긴급' };
        return map[priority] || priority;
    }

    public priorityClass(priority: string) {
        const map: any = {
            'low': 'text-gray-500',
            'medium': 'text-yellow-600',
            'high': 'text-orange-600',
            'critical': 'text-red-600 font-bold'
        };
        return map[priority] || 'text-gray-500';
    }

    public priorityBadgeClass(priority: string) {
        const map: any = {
            'low': 'bg-gray-50 text-gray-600 border-gray-200',
            'medium': 'bg-yellow-50 text-yellow-700 border-yellow-200',
            'high': 'bg-orange-50 text-orange-700 border-orange-200',
            'critical': 'bg-red-50 text-red-700 border-red-200'
        };
        return map[priority] || 'bg-gray-50 text-gray-600 border-gray-200';
    }

    public supportStatusLabel(status: string) {
        const map: any = {
            'requested': '재이관 대기',
            'in_progress': '재이관 처리중',
            'resolved': '재이관 처리 완료',
            'confirmed': '확인 완료',
            'closed': '확인 완료'
        };
        return map[status] || status;
    }

    public rowStatus(ticket: any) {
        return ticket?.infra_status || ticket?.status || '';
    }

    public getPageNumbers(): any[] {
        const totalPages = Math.ceil(this.total / this.dump);
        if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
        const pages: any[] = [1];
        if (this.page > 3) pages.push('...');
        for (let i = Math.max(2, this.page - 1); i <= Math.min(totalPages - 1, this.page + 1); i++) {
            pages.push(i);
        }
        if (this.page < totalPages - 2) pages.push('...');
        pages.push(totalPages);
        return pages;
    }

    public async goToPage(p: any) {
        if (typeof p === 'number' && p !== this.page) {
            this.page = p;
            await this.load();
        }
    }

    public isVariantC() {
        return this.variant === 'c';
    }

    public isVariantF() {
        return this.variant === 'f';
    }

    public isVariantG() {
        return this.variant === 'g';
    }

    public hasVariant() {
        return this.isVariantC() || this.isVariantF() || this.isVariantG();
    }

    public variantTitle() {
        if (this.isVariantC()) return 'C안 티켓 목록';
        if (this.isVariantF()) return 'F안 티켓 목록';
        if (this.isVariantG()) return 'G안 작업 큐';
        return '이관 티켓 관리';
    }

    public ticketDetailLink(ticket: any) {
        return [this.listBasePath(), ticket.id, 'view'];
    }

    public detailQueryParams() {
        if (this.isVariantC()) return { variant: 'c' };
        if (this.isVariantF()) return { variant: 'f' };
        if (this.isVariantG() && this.listBasePath() === '/tickets') return { variant: 'g' };
        return {};
    }

    public listBasePath() {
        if (this.isVariantG()) return this.basePath || '/tickets-g';
        return '/tickets';
    }

    public statusCount(key: string) {
        return this.stats?.[key] || 0;
    }

    public gStatusTabClass(status: string) {
        const active = this.status === status;
        return active
            ? 'inline-flex min-w-[92px] items-center justify-center gap-2 rounded-md border border-gray-900 bg-gray-900 px-3 py-2 text-[12px] font-bold text-white'
            : 'inline-flex min-w-[92px] items-center justify-center gap-2 rounded-md border border-gray-200 bg-white px-3 py-2 text-[12px] font-semibold text-gray-700 hover:bg-gray-50';
    }

    public gStatusTabCountClass(status: string) {
        return this.status === status
            ? 'rounded-full bg-white px-2 py-0.5 text-[10px] font-bold text-gray-900'
            : 'rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-bold text-gray-600';
    }

    private pathVariant() {
        const path = location.pathname || '';
        return path === '/tickets-g' || path.indexOf('/tickets-g/') === 0 ? 'g' : '';
    }
}

export default PortalTicketingListComponent;